import dayjs from 'dayjs';

import { WEEKENDS } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const isDayOff = (day: string) => [ WEEKENDS.Sunday, WEEKENDS.Saturday ].includes(dayjs(day).get('day')); // 0 and 6 is a sunday and saturday 
